const useAllowedActions = (domain) => {
  const activeSubscriptions = domain.domainSubscriptions.filter((s) => s.status === 'active');
  if (activeSubscriptions.length === 0) {
    return null;
  }

  return activeSubscriptions.reduce((accu, sub) => {
    sub.appliedValues.allowedActions.map((a) => accu.add(a));
    return accu;
  }, new Set());
};

export default useAllowedActions;
